'use client';
import { Tooltip } from 'tdesign-react';
export interface IHelpTitleProps {
  title: string;
  help?: string;
  onlyTitle?: boolean;
}
export const HelpTitle: React.FC<IHelpTitleProps> = ({
  title,
  help,
  onlyTitle,
}) => {
  const content = (
    <span className="w-4 h-4 rounded-full bg-[#BEC5CD] ml-[6px] flex items-center justify-center cursor-help pointer-events-auto mobile:h-[14px] mobile:w-[14px]">
      <span className="text-white text-xs">?</span>
    </span>
  );
  return (
    <p className="flex items-center mt-[3px]">
      <span
        className="text-sm -leading-[1px] text-primary/60 mobile:text-[10px]"
        dangerouslySetInnerHTML={{ __html: title }}
      />
      {onlyTitle ? null : help ? (
        <Tooltip
          content={help}
          placement="right-top"
          destroyOnClose
          showArrow
          theme="default"
          overlayClassName="max-w-[200px]"
        >
          {content}
        </Tooltip>
      ) : (
        content
      )}
    </p>
  );
};
